import mixins from 'vue-typed-mixins';
import { AxiosResponse } from 'axios';
import _ from 'lodash';
import { ErrorResponse } from '@codequality/vue-cli-base';

import { データApi, データRequest } from '@/openapi/user';
import { E入力分類 } from '@/openapi/enum';

import C役員借入EditRow from '@/entries/user/pages/authorized/事業所/計画書/分析計画/借入/役員借入/役員借入EditRow/役員借入EditRow.vue';
import AlertMixin from '@/mixins/AlertMixin';
import ListMixin from '@/entries/user/mixins/ListMixin';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';
import フェーズ種別Mixin from '@/entries/user/mixins/フェーズ種別Mixin';

import UserApiUtility from '@/classes/common/UserApiUtility';
import 役員借入Service, { 役員借入, 役員借入ListItem } from '@/classes/service/分析計画/役員借入Service';
import OldLoanMixin from '@/entries/user/mixins/OldLoanMixin';
import 返済明細Service from '@/classes/service/計画/返済明細Service';

const initialEditItem = (): 役員借入ListItem => {
  return {
    役員名: '',
    返済開始時期: '',
    備考: '',
    元本返済: [],
    利息: [],
  };
};

export default mixins(AlertMixin, ListMixin, RoutesMixin, 計画書Mixin, フェーズ種別Mixin, OldLoanMixin).extend({
  name: 'C役員借入',

  components: {
    C役員借入EditRow,
  },

  data(): {
    service: 役員借入Service;
    返済明細Service: 返済明細Service;
    api: データApi;
    v役員借入: 役員借入 | null;
    new役員借入: 役員借入ListItem;
    edit役員借入: 役員借入ListItem;
  } {
    return {
      service: new 役員借入Service(),
      返済明細Service: new 返済明細Service(),
      api: UserApiUtility.ogApi(データApi),
      v役員借入: null,
      new役員借入: initialEditItem(),
      edit役員借入: initialEditItem(),
    };
  },

  created(): void {
    this.$_load();
  },

  methods: {
    async $_load(): Promise<void> {
      const response = await this.api.listデータ(
        this.計画書.pk,
        this.service.getRelationalE入力分類s(),
        this.apiフェーズ種別,
        this.mockApiOptions('役員借入', true)
      );
      this.v役員借入 = this.service.parse(response.data);
      const 返済明細 = this.返済明細Service.parse(response.data);
      const oldData = this.返済明細Service.createTデータOldLoans(response.data);
      this.getOldLoans(oldData, 返済明細);
    },

    selectForEdit(v借入: 役員借入ListItem): void {
      this.edit役員借入 = _.cloneDeep(v借入);
    },

    clearForm(isNew: boolean): void {
      const init = initialEditItem();
      if (isNew) {
        this.new役員借入 = init;
      } else {
        this.edit役員借入 = init;
      }
    },

    async save(isNew: boolean, editItem: 役員借入ListItem): Promise<void> {
      // 入力チェック
      if (editItem.元本返済額月 !== undefined && (editItem.返済開始時期 === null || editItem.返済開始時期 === '')) {
        alert('元本返済額(月)を入力した場合、返済開始時期は入力必須です。');
        return;
      }

      const { データpk, 番号, ...役員借入 } = editItem;
      const request: データRequest = {
        c入力分類: E入力分類.役員借入,
        c番号: 番号!,
        cフェーズ種別: this.eフェーズ種別,
        cデータ: JSON.stringify(役員借入),
      };
      this.updateRequestSave(request);

      const response: AxiosResponse<void | ErrorResponse> = isNew
        ? await this.api.createデータ(this.計画書.pk, request)
        : await this.api.updateデータ(データpk!, request);

      if (this.isValidationErrorResponse(response)) return;
      this.$_clearAndLoad();
    },

    async remove(データpk: number): Promise<void> {
      const isCancelOrError = await this.isCancelOrValidationErrorResponseToDelete(() =>
        this.api.deleteデータ(データpk)
      );
      if (isCancelOrError) return;
      this.$_clearAndLoad();
    },

    $_clearAndLoad() {
      this.clearForm(true);
      this.clearForm(false);
      this.$_load();
    },
  },
});
